export default "__VITE_ASSET__LluFkgRk__"